export default class NavigationPosition {
  public position = 1;
  public totalItems = 1;
  public previousItem?: string;
  public nextItem?: string;
}
